/* jshint esversion: 6 */
import React from 'react';
import Draggable from 'react-draggable';
import { Breakpoint } from 'react-socks';

class MinimalModal extends React.Component {
    constructor(props) {
        super(props);

        this.keyListener = this.keyListener.bind(this);
        this.draggableRef = React.createRef();

    }

    componentDidMount() {
        window.addEventListener('keyup', this.keyListener);

        window.location.hash = "modal"
    }

    componentDidUpdate() {
        // catch the back button
        if (window.location.hash !== "#modal" && this.props.ignoreBack === undefined) {
            this.props.cancelAction();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('keyup', this.keyListener);

        let cleanUrl = window.location.href.substring(0, window.location.href.indexOf("#"));
        window.history.replaceState({}, '', cleanUrl);

    }

    keyListener(e) {
        if (e.keyCode === 27) {
            this.props.cancelAction();
        }
    }

    render() {
        let className = 'pt-accessory-modal',
            uploadcareTypes = ['gdrive', 'gphotos', 'dropbox', 'onedrive'];

        if (['imageEditor', 'mediaUploader', 'fullEditor'].indexOf(this.props.mode) !== -1) {
            className += ' image-editor';
        }

        if (this.props.mode === 'fullEditor') {
            className += ' full-editor';
        }

        if (this.props.mode === 'videoEditor') {
            className += ' video-editor';
        }

        if (this.props.mode === 'galleryChooser') {
            className += ' gallery-chooser';
        }

        if (this.props.mode === 'confirmPromo') {
            className += ' confirm-promo'
        }

        if (this.props.mode === 'aiHelper') {
            className += ' ai-helper';
        }

        if (this.props.mode === 'welcome') {
            className += ' welcome';
        }

        if (this.props.mode === "resubscribe") {
            className += ' resubscribe';
        }

        if (uploadcareTypes.indexOf(this.props.mode) !== -1) {
            className += ' uploadcare-wrapper';
        }

        return (
            <div className="dlvr-modal">
                <Breakpoint desktop only>
                    <Draggable nodeRef={this.draggableRef} handle=".pt-accessory-modal" cancel=".pt-accessory-close, .action-cancel, .action-delete, .pt-scheduler, .gallery-search, .image-editor-display, .pt-accessory-content, .image-list">
    					<div ref={this.draggableRef} className={className} role="dialog" aria-modal="true">
                            <div role="button" aria-label="close modal" className="pt-accessory-close" onClick={this.props.cancelAction}>
                                <i className="fa fa-times"></i>
                            </div>
                            <div className="pt-accessory-content" role="dialog">
                                {this.props.content}
                            </div>
    					</div>
    				</Draggable>
                </Breakpoint>
				<Breakpoint mobile only>
                    <div className={className} role="dialog" aria-modal="true">
                        <div role="button" aria-label="close modal" className="pt-accessory-close" onClick={this.props.cancelAction}>
                            <i className="fa fa-times"></i>
                        </div>
                        <div className="pt-accessory-content" role="dialog">
                            {this.props.content}
                        </div>
                    </div>
                </Breakpoint>
			</div>
        );
    }
}

export default MinimalModal;
